'use client';

import { useEffect } from 'react';
import { useFbtContext } from './fbt-context-provider';
import { checkObjectDeepEqual } from '../utils';

interface FbtItemSummaryContextEntryProps {
  itemSummary: ISummary;
  listenerKey: string;
}

const FbtItemSummaryContextEntry = ({
  itemSummary: itemSummaryProps,
  listenerKey
}: FbtItemSummaryContextEntryProps) => {
  const { itemSummary, setItemSummary } = useFbtContext();

  useEffect(() => {
    if (!checkObjectDeepEqual(itemSummaryProps, itemSummary)) {
      setItemSummary(itemSummaryProps);
    }
  }, [itemSummaryProps, listenerKey, itemSummary, setItemSummary]);

  return null;
};

export default FbtItemSummaryContextEntry;
